<template>
  <div class="subscription-information mt-5 lg:mt-10">
    <the-section :title="$t('ec-line004.subscriptionInformation.title')">
      <el-form ref="subscription-form" class="subscription-information__form" label-position="top">
        <el-form-item :label="$t('common.label.deliveryPattern')">
          <disabled-input :value="data.delivery_pattern" />
          <!-- <el-input type="text" disabled :value="data.delivery_pattern"></el-input> -->
        </el-form-item>
        <el-form-item :label="$t('common.label.deliveryInterval')">
          <el-row :gutter="24">
            <el-col :span="12">
              <disabled-input :value="data.delivery_interval" />
              <!-- <el-input type="text" disabled :value="data.delivery_interval"></el-input> -->
            </el-col>
            <el-col :span="12">
              <span>{{
                $t('common.label.deliveryIntervalNote', { date: $date.getDate(data.next_delivery_date_often) })
              }}</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('ec-line004.subscriptionInformation.nextDeliveryDateOften')">
          <disabled-input :value="Utils.date.formatDateJP(data.next_delivery_date_often)" />
          <!-- <el-input type="text" disabled :value="Utils.date.formatDateJP(data.next_delivery_date_often)"></el-input> -->
        </el-form-item>
        <el-form-item :label="$t('ec-line004.subscriptionInformation.nextDeliveryDate')">
          <disabled-input :value="Utils.date.formatDateJP(data.next_delivery_date)" />
          <!-- <el-input type="text" disabled :value="Utils.date.formatDateJP(data.next_delivery_date)"></el-input> -->
        </el-form-item>
      </el-form>
    </the-section>
  </div>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import DisabledInput from '@/components/DisabledInput.vue'

export default {
  components: { TheSection, DisabledInput },
  props: {
    data: { type: Object, default: () => {} },
  },
}
</script>
